import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";

const ErrorAlert = props => {

  const [alert, setAlert] = useState(true);

  useEffect(() => {
    // when the component is mounted, the alert is displayed for 20 seconds, unless persistant prop is present
    const timeId = setTimeout(() => {       
      if (! props.persistant)
        setAlert(false);

    }, 15 * 1000);
    
    return () => {
      clearTimeout(timeId)
    }
  }, [props.error, props.persistant]);  

  useEffect(() => {
    setAlert(true)
  }, [props.error, props.lastStateUpdate])

  return props.error && alert ? (
    <div className="alert alert-danger" role="alert">{props.error}</div>
  ) : null
  
};

ErrorAlert.propTypes = {
  error: PropTypes.string,
  persistant: PropTypes.bool,
  lastStateUpdate: PropTypes.object
};
export default ErrorAlert;